import * as React from 'react';
import { useAccountPositionGesEstimDPv } from '../../hooks';
import { usePersonAccountsCCurrencyTAccCode } from '../../../../persons';
import { ActorApiNumberDisplayCurrency } from '../../../../../../components/display/number/currency';

export const AccountsPositionsGesEstimDPV = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionGesEstimDPv();
  const {
    data: currencyData,
    isLoading: currencyIsLoading,
    error: currencyError,
  } = usePersonAccountsCCurrencyTAccCode();
  return (
    <ActorApiNumberDisplayCurrency
      data={data}
      isLoading={isLoading}
      error={error}
      currencyData={currencyData}
      currencyIsLoading={currencyIsLoading}
      currencyError={currencyError}
    />
  );
};
